import { Modal, Pagination } from "@mui/material";
import adminAPIs from "apis/AdminApis";
import { useEffect, useState } from "react";
const base_URL = process.env.REACT_APP_API_BASE_URL;

function ViewUsers() {
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [passoutYear, setPassoutYear] = useState("");
  const usersPerPage = 50;


  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async (page = 1, searchTerm = "", passoutYear = "") => {
    setLoading(true);
    try {

      const data = await adminAPIs.allUsers(page, searchTerm, passoutYear);
      setUsers(data?.data?.data?.users || []);
      setTotalPages(Math.ceil(data?.data?.data?.count / usersPerPage));
    } catch (err) {
      console.log("Error", err);
      setError("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    console.log("Search term", value);
    setSearchTerm(value);
    setCurrentPage(1);
    fetchUsers(1, value);
  };
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    fetchUsers(value, searchTerm, passoutYear);
  };








  const handleDelete = async (userId) => {
    if (confirm("Are you sure you want to delete this user? This action cannot be undone.")) {
      setLoading(true);
      try {
        // await adminAPIs.deleteUser(userId); // Uncomment when API is available
        await fetchUsers();
        setSuccess("User successfully deleted!");
      } catch (err) {
        console.log(err);
        setError("Failed to delete user");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleVerify = async (userId, verifyStatus) => {
    setLoading(true);
    try {
      await adminAPIs.verifyUser(userId, verifyStatus); // Uncomment when API is available
      const usersUpdated = users.map((user) => user.id === userId ? { ...user, verified_member: verifyStatus } : user);
      setUsers(usersUpdated);
      setSuccess(`User ${!verifyStatus ? 'verified' : 'unverified'} successfully!`);
    } catch (err) {
      console.log(err);
      setError("Failed to update user verification status");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit =  async (userId, verifyStatus) => {
    try {
      await adminAPIs.setPaidUser(userId, true); // Uncomment when API is available
      const usersUpdated = users.map((user) => user.id === userId ? { ...user, membership_paid: true } : user);
      setUsers(usersUpdated);
      setSuccess(`User ${!verifyStatus ? 'verified' : 'unverified'} successfully!`);
    } catch (err) {
      console.log(err);
      setError("Failed to update user verification status");
    } finally {
      setLoading(false);
    }
  };
  const openUserProfile = (user) => {
    console.log("User", user);
    //open Modal
    setIsModalOpen(true);
    setEditingUser(user);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 font-inter">Users Management</h1>
          <p className="mt-2 text-gray-600">View and manage users</p>
        </div>

      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600">
          <i className="fas fa-exclamation-circle mr-2"></i>
          {error}
        </div>
      )}

      {success && (
        <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-600">
          <i className="fas fa-check-circle mr-2"></i>
          {success}
        </div>
      )}

      {/* Users List */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        {/*search bar*/}
        <div className="p-6">
          <input type="text" placeholder="Search by name or email" className="w-full p-2 rounded-md border border-gray-300" onChange={handleSearch} />
        </div>
        {loading ? (
          <div className="p-6">
            <div className="animate-pulse space-y-4">
              {[...Array.from({ length: 5 })].map((_, i) => (
                <div key={i} className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                    <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                  </div>
                  <div className="h-8 bg-gray-200 rounded w-20"></div>
                </div>
              ))}
            </div>
          </div>
        ) : users.length === 0 ? (
          <div className="p-8 text-center text-gray-500">
            <i className="fas fa-users text-4xl mb-4"></i>
            <p>No users found</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    User
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Contact
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    School Info
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Role & Status
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {users.map((user) => (
                  <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-12 w-12 cursor-pointer" onClick={() => openUserProfile(user)}>
                          {user.profile_image ? (
                            <img
                              className="h-12 w-12 rounded-full object-cover"
                              src={base_URL + "/get-image?objectKey=" + user.profile_image}
                              alt={`${user.first_name} ${user.last_name}`}
                            />
                          ) : (
                            <div className="h-12 w-12 rounded-full bg-gray-300 flex items-center justify-center">
                              <i className="fas fa-user text-gray-600"></i>
                            </div>
                          )}
                        </div>
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">
                            {user.first_name} {user.last_name}
                            <br />
                            <span className="text-sm text-gray-500">Membership :</span>
                            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                              user.membership_paid
                                ? "bg-green-100 text-green-800"
                                : "bg-red-100 text-red-800"
                              }`}>
                              {user.membership_paid ? "Paid" : "Unpaid"}</span>
                          </div>
                          <div className="text-sm text-gray-500">
                          {user.occupation && (
                        <div className="text-sm text-gray-500">{user.occupation}</div>
                      )}
                      {user.speciality && (
                        <div className="text-sm text-gray-500">{user.speciality}</div>
                      )}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{user.email}</div>
                      <div className="text-sm text-gray-500">{user.mobile_num}</div>
                      {user.address && (
                        <div className="text-sm text-gray-500 truncate max-w-xs" title={user.address}>
                          {user.address}
                        </div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">School: {user.school_num}</div>
                      <div className="text-sm text-gray-500">Grad Year: {user.grad_year}</div>

                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex flex-col space-y-1">
                        {user.role && user.role.length > 0 && (
                          <div className="flex flex-wrap gap-1">
                            {user.role.map((role, index) => (
                              <span
                                key={index}
                                className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800"
                              >
                                {role}
                              </span>
                            ))}
                          </div>
                        )}
                        <div className="flex items-center space-x-2">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                              user.verified_member
                                ? "bg-green-100 text-green-800"
                                : "bg-yellow-100 text-yellow-800"
                            }`}
                          >
                            {user.verified_member ? "Verified" : "Unverified"}
                          </span>
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                              user.private_info
                                ? "bg-red-100 text-red-800"
                                : "bg-gray-100 text-gray-800"
                            }`}
                          >
                            {user.private_info ? "Private" : "Public"}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex space-x-2">

                        {user.verified_member && <button

                          onClick={() => handleVerify(user.id, false)}
                          className={`transition-colors px-4 py-2 rounded-md bg-red-100 text-red-800`}
                        >Unverify User
                        </button>}
                        {!user.verified_member && <button

                          onClick={() => handleVerify(user.id, true)}
                          className={`transition-colors px-4 py-2 rounded-md bg-green-500 text-white`}
                        >Verify User
                        </button>}
                        {!user.membership_paid && <button
                          onClick={() => handleEdit(user.id, true)}
                          className="text-gray-500 hover:text-gray-700 bg-green-500 text-white px-4 py-2 rounded-md"
                          title={user.membership_paid ? "Unpaid Membership" : "Paid Membership"}
                        >Set Paid
                        </button>}

                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>


                </table>
                 {/*pagination*/}
                <div className="mt-6 flex justify-center">
                <Pagination count={totalPages} page={currentPage} onChange={handlePageChange} color="primary" />
              </div>
          </div>
        )}
      </div>
      {isModalOpen && ( <UserProfileModal user={editingUser} onClose={() => setIsModalOpen(false)}  isModalOpen={isModalOpen}/> )}


    </div>
  );

}

const UserProfileModal = ({ user, onClose , isModalOpen}) => {
  return (
    <Modal open={isModalOpen} onClose={onClose} sx={{ display: "grid", placeItems: "center" , zIndex: 1000, overflow: "auto" }}>
      <div className="bg-white rounded-xl shadow-md overflow-hidden w-full max-w-2xl mx-4">

        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-2xl font-bold text-gray-900 font-inter">{user.first_name} {user.last_name} Profile</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <i className="fas fa-times text-xl"></i>
          </button>
        </div>

        <div className="p-6">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="flex-1">
              <img src={user.profile_image ? (base_URL + '/get-image?objectKey=' + user.profile_image) : "https://www.gravatar.com/avatar/?d=mp"} alt={user.first_name + " " + user.last_name} className="w-full h-full object-cover rounded-2xl " style={{width: '200px', height: '200px', borderRadius: '10px', margin: '20px auto', display: 'block'}}/>
            </div>
            <div className="flex-1">
            <p className="text-gray-900 font-bold text-sm">School Info:</p>
              <p className="text-gray-500">{user.school_num}</p>
              <p className="text-gray-500">{user.grad_year}</p>
              <p className="text-gray-900 font-bold text-sm">Occupation:</p>
              <p className="text-gray-500">{user.occupation}</p>
              <p className="text-gray-500">{user.speciality}</p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row gap-8">
            <div className="flex-1">
              <p className="text-gray-900 font-bold">{user.first_name} {user.last_name}</p>
              <p className="text-gray-700 font-bold text-sm">Contact:</p>
              <p className="text-gray-500">{user.email}</p>
              <p className="text-gray-500">{user.mobile_num}</p>
              <p className="text-gray-500">{user.address}</p>



            </div>
          </div>
        </div>
      </div>


    </Modal>
  );
};



export default ViewUsers;
